const WarningMessageOnDelete = ({ type }) => {
  if (type) {
    return (
      <>
        Please verify that this {type} is not part of any workflows or campaigns before proceeding with deletion.
        <br />
        This action cannot be undone!
      </>
    );
  }
};

export default WarningMessageOnDelete;
